import { formatPhoneNumberIntl, parsePhoneNumber } from 'react-phone-number-input';

export function formatPhoneNr(phoneNr: string | undefined | null): string {
  phoneNr = phoneNr?.replace(/\s/g, '') ?? '';
  if (!phoneNr) return '';

  const phoneNrType = parsePhoneNumber(phoneNr, 'NO');
  if (phoneNrType) {
    return formatPhoneNumberIntl(phoneNrType.number);
  }

  return '';
}
